/* eslint-disable */
import listing from "@/apollo/packages/listing/listing.gql";

export const state = () => ({
  list: [],
  loading: false
});

export const mutations = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 01 Apr 2024 | 06:07PM
   * @param {*} state
   * @param {*} value
   */
  setListing: (state, value) => (state.list = value),
  /**
   * @description
   * @author Saurabh Jangra
   * @date 01 Apr 2024 | 06:07PM
   * @param {*} state
   * @param {*} value
   */
  setLoading: (state, value) => (state.loading = value)
};

export const actions = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 01 Apr 2024 | 06:07PM
   * @param {*} { commit }
   * @returns {*}
   */
  fetchListing({ commit }) {
    commit("setLoading", true);
    commit("setListing", []);
    return new Promise((resolve) => {
      this.$apolloClient
        .query({ query: listing })
        .then(({ data }) => {
          commit("setListing", data.pkgListing);
          resolve(data.pkgListing);
          commit("setLoading", false);
        })
        .catch((err) => {
          commit("setLoading", false);
        });
    });
  }
};

export const getters = {
  list: (state) => state.list,
  loading: (state) => state.loading
};
